export default __webpack_public_path__ + "static/media/16.5f7ba610.mp3";